// @flow
import React, { Fragment } from 'react';
import BannerHead from 'components/banner/BannerHead';
import './BannerPlaceholder.scss';
import BannerContent from '../BannerContent';

type Props = {};

const BannerPlaceholder = (props: Props) => (
  <Fragment>
    <BannerHead.Placeholder />
    <BannerContent.Placeholder />
  </Fragment>
);

export default BannerPlaceholder;



// WEBPACK FOOTER //
// ./src/components/banner/BannerPlaceholder/BannerPlaceholder.js